import React, { useState } from "react";
import { RotateCcw, Star } from "lucide-react";

// A 3D book that flips to reveal its back cover + synopsis.
// Desktop: flips on hover. Touch: flips on tap. Persists on click.
const FlipBookCover = ({ cover, title, label, synopsis, year, testId }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="flip-book aspect-[2/3] w-full">
      <button
        type="button"
        onClick={() => setFlipped((f) => !f)}
        aria-label={flipped ? `Flip ${title} to front cover` : `Flip ${title} to read the back`}
        data-testid={testId}
        className="block w-full h-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/70 rounded-2xl"
      >
        <div className={`flip-book-inner ${flipped ? "is-flipped" : ""}`}>
          {/* FRONT — cover art */}
          <div className="flip-face">
            <img src={cover} alt={title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
              <span className="font-accent text-amber-200 text-lg">{label}</span>
              {year && (
                <span className="px-3 py-1 rounded-full bg-amber-400/20 backdrop-blur-md border border-amber-400/40 text-xs text-amber-100 font-medium">
                  {year}
                </span>
              )}
            </div>
            {/* flip hint */}
            <span className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/45 backdrop-blur-md border border-amber-400/30 text-[11px] text-amber-100">
              <RotateCcw size={12} /> Flip
            </span>
          </div>

          {/* BACK — synopsis */}
          <div className="flip-face flip-face-back p-6 flex flex-col">
            <div className="text-[10px] uppercase tracking-[0.3em] text-amber-300/80">
              Back Cover
            </div>
            <h4 className="font-heading text-xl text-white mt-2 leading-snug">
              {label}
            </h4>
            <div className="flex items-center gap-1 mt-2 text-amber-400">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={12} fill="currentColor" stroke="none" />
              ))}
              <span className="text-[11px] text-emerald-50/60 ml-1">Ages 6–12</span>
            </div>
            <p className="mt-4 text-emerald-50/85 text-sm leading-relaxed overflow-y-auto pr-1 flex-1">
              {synopsis}
            </p>
            <div className="mt-4 pt-3 border-t border-amber-400/15 flex items-center justify-between">
              <span className="font-accent text-amber-300/90 text-sm">
                Sybelle Cheesman
              </span>
              <span className="flex items-center gap-1.5 text-[11px] text-emerald-50/55">
                <RotateCcw size={12} /> Flip back
              </span>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default FlipBookCover;
